import { internationalReadinessSchema } from "@redotech/redo-return-core-common/international-readiness";
import * as z from "zod";

export const getInternationalReadiness = {
  name: "getInternationalReadiness" as const,
  input: z.null(),
  output: internationalReadinessSchema,
};
